import * as yup from 'yup';

// const getCharacterValidationError = (str) => {
//     return `Your password must have at least 1 ${str} character`;
// };

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .min(5, "Password must be at least 5 characters")
        // .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
        .required("Required")
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .min(5, "Password must be at least 5 characters")
        // .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
        .required("Required")
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    username: yup
        .string()
        .required("Required"),
    firstname: yup
        .string()
        .required("Required"),
    lastname: yup
        .string()
        .required("Required"),
    email: yup
        .string()
        .email('Enter a valid email')
        .required("Required"),
    // contactno: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    // address: yup
    //     .string()
    //     .required("Required"),
    locationId: yup.array()
        .of(yup.string())
        .min(1, "Min 1 selection")
        .required('Required'),
})

export const initialPasswordValues = {
    password: "",
    passwordconfirm: "",
}

export const initialValues = {
    username: "",
    firstname: "",
    lastname: "",
    contactno: "",
    email: "",
    address: "",
    status: true,
    locationId: []
}